import { Modal } from "antd";
import styled from "styled-components/macro";
import React from "react";
import { Icon } from "components/hds";

export interface HegiasModalProps extends React.ComponentProps<typeof Modal> {
	size?: string;
	justifycontent?: string;
	children?: React.ReactNode;
}

export const StyledModal = styled(Modal)`
	max-width: ${({ size }: HegiasModalProps) => {
		if (size === "xlarge") {
			return "1800px";
		}
		if (size === "large") {
			return "1000px";
		}
		if (size === "medium") {
			return "750px";
		}
		if (size === "small") {
			return "350px";
		}
	}};
	${({ size }: HegiasModalProps) => {
		if (size === "xlarge") {
			return `
				width: 95% !important;
				max-height: 95vh !important;
				top: 60px !important;
				content:"${size}";
			`;
		}
		if (size === "large" || size === "medium") {
			return `
				width: 90% !important;
				content:"${size}";
			`;
		}
		return '';
	}}
	.ant-modal-body {
		overflow: ${({ size }: HegiasModalProps) => size === "xlarge" ? "auto" : "hidden"};
		max-height: ${({ size }: HegiasModalProps) => size === "xlarge" ? "calc(95vh - 120px)" : "auto"};
		/* §2: a sub-heading and a modal title are both --font-weight-medium. The
		   theme's weight map only carries thin/normal/bold, so these read the
		   token directly — and this is what hds/Modal already does. */
		h5 {
			color: ${({ theme }) => theme.colors.grey800};
			font-weight: var(--font-weight-medium);
		}
	}
	.ant-modal-header {
		.ant-modal-title {
			color: ${({ theme }) => theme.colors.grey800};
			font-weight: var(--font-weight-medium);
		}
	}
	/* §8: the close button is a 24px icon, not a control.

	   antd derives its size from modalCloseBtnSize, which is controlHeight —
	   48px here (§5) — so it drew a 48x48 button around a 20px glyph and read as an
	   action rather than as dismiss chrome. That token is derived, not exposed on
	   ConfigProvider, so the size is corrected here instead. The
	   inset matches the modal's own 32px padding, which is what "aligned to the
	   title" means. */
	.ant-modal-close {
		width: var(--size-icon);
		height: var(--size-icon);
		top: var(--space-8);
		inset-inline-end: var(--space-8);
	}
	.ant-modal-close-x {
		display: flex;
		align-items: center;
		justify-content: center;
		width: var(--size-icon);
		height: var(--size-icon);
		line-height: 1;
	}
	.ant-modal-footer {
		display: flex;
		justify-content: ${({ justifycontent }: HegiasModalProps) => {
			if (justifycontent === "left") {
				return "left";
			}
			return "flex-end";
		}};
	}
`;

const HegiasModal = ({ visible, open, ...props }: HegiasModalProps) => {
	return (
		<StyledModal
			{...props}
			// `visible` is deprecated in antd; accept it from call sites and
			// forward it as `open` so no deprecation warning is emitted.
			open={open ?? visible}
			closeIcon={
				<Icon name="CloseIcon" size="20px" hoverColor="primary" />
			}
		/>
	);
};

export default HegiasModal;
